import Modal from "../../../../components/Modal";
import Table from "../../../../components/tables/Table";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import EditButton from "../../../../components/EditButton";
import HideButton from "../../../../components/HideButton";
import SaveDataButton from "../../../../components/SaveDataButton";
import { toast } from "../../../../components/toastNotification";
import { useRecoilState, useRecoilValue } from "recoil";
import { franchiseCheckBox, prodCodeMassUpload } from "../atom";
import {
  downloadProdCodeTemplate,
  massUploadProducerCode,
  validateMassUpload,
} from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { useEffect, useState } from "react";
import { MassUploadFullView } from "./MassUploadFullView";
import ShowButton from "../../../../components/ShowButton";
import ReactTooltip from "react-tooltip";
import { useQueryClient } from "react-query";
import * as XLSXFiles from "xlsx";
import UploadFileButton from "../../../../components/UploadFileButton";
import TemplateButton from "../../../../components/TemplateButton";

const MassUpload = ({ isOpen }) => {
  const [, setMassUpload] = useRecoilState(prodCodeMassUpload);
  const user = useRecoilValue(accountAtom);
  const [xlsx, setXlsx] = useState<any>(null);
  const [validData, setValidData] = useState<any>(null);
  const [invalidData, setInvalidData] = useState<any>(null);
  const [selectedTab, setSelectedTab] = useState("All");
  const [origData, setOrigData] = useState<any>([]);
  const [, setLoading] = useState(false);
  const [DisplayNote, setDisplayNote] = useState(false);
  const [allData, setAllData] = useState([]);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [buttonSaveText, setButtonSaveText] = useState("Save Data");
  const queryClient = useQueryClient();
  const franchiseCheckBoxValue = useRecoilValue(franchiseCheckBox);

  const [show, setShow] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [toggleClear, setToggleCleared] = useState(false);

  const hasValidData =
    origData && origData?.filter((data: any) => data.isValid).length > 0;
  useEffect(() => {
    const scriptShim = document.createElement("script");
    scriptShim.async = true;
    scriptShim.src =
      "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.17.3/shim.min.js";
    scriptShim.integrity =
      "824a6ade25af712b2dabb1dc9d30f3441b5b1652fd7fa43a9f6ba99607849a6334c1baf0085047e4d2692a06e4ed299af067d71ffdf7986225cc041c6d8d71b8"; //C0nF!esH1m //sha512
    scriptShim.crossOrigin = "anonymous";

    const scriptXLS = document.createElement("script");
    scriptXLS.async = true;
    scriptXLS.src =
      "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.17.3/xlsx.full.min.js";
    scriptXLS.integrity =
      "ce7e2434109f7c48061d1a110f5d2082e827dd41a0d9bb3950be8e3adea03f7508aa287b5c177754cf32dab771212d7de2f03d8a19d685b0dfc8a8452fd8172f"; //C0nF!eXLs //sha512
    scriptXLS.crossOrigin = "anonymous";

    scriptXLS.onload = () => setXlsx(XLSXFiles);

    document.body.appendChild(scriptShim);
    document.body.appendChild(scriptXLS);

    let timer = setTimeout(() => setLoading(false), 2000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const columns = [
    {
      name: "Findings",
      left: "true",
      cell: (row) => {
        return (
          <div className=" items-left text-left">
            {row.isValid ? (
              <>
                {row.warnings !== "" ? (
                  <>
                    <ReactTooltip place="right" effect="solid" type="info" />
                    <div
                      className=" items-left text-left"
                      data-tip={row.warnings}
                    >
                      {row.warnings.substring(0, 12).trim()}
                    </div>
                  </>
                ) : (
                  <>
                    <div className=" items-left text-left"> Valid</div>
                  </>
                )}{" "}
              </>
            ) : (
              <>
                <ReactTooltip place="right" effect="solid" type="info" />{" "}
                <div data-tip={row.findings + row.warnings}>
                  {row.findings?.length > 20 ? (
                    <>{row.findings.substring(0, 20).trim() + "..."}</>
                  ) : (
                    <> {row.findings}</>
                  )}
                </div>
              </>
            )}
          </div>
        );
      },
    },
    {
      name: "Carrier",
      cell: (row) => {
        return <div className=" items-left text-left">{row.carrierName}</div>;
      },
    },
    {
      name: "Office Code",
      screenLeft: true,
      cell: (row) => {
        return <div className="">{row.officeCode}</div>;
      },
    },
    {
      name: "Store Number",
      cell: (row) => {
        return <div className="">{row.storeNumber}</div>;
      },
    },
    {
      name: "Producer Code/Princeton Code",
      cell: (row) => {
        return <div className=" ">{row.producerCode}</div>;
      },
    },
    {
      name: "Code Level",
      cell: (row) => {
        return <div className="">{row.codeLevel}</div>;
      },
    },
    {
      name: "Line of Business",
      cell: (row) => {
        return <div className=" ">{row.lineOfBusiness}</div>;
      },
    },
    {
      name: "MA Producer Code",
      cell: (row) => {
        return <div className=" ">{row.mAproducerCodes}</div>;
      },
    },
    {
      name: "Actions",
      center: true,
      cell: (row) => {
        return (
          <div className="flex 2xl:flex-row flex-col justify-center items-center">
            <div className="flex flex-row">
              {row.expandRow ? (
                <HideButton
                  buttonText="Hide"
                  onClick={() => {
                    handleActions(row, "Hide");
                  }}
                  className={undefined}
                />
              ) : (
                ""
              )}
              <div className="flex flex-row flex-col justify-center items-center opacity-100 gap-x-2 space-x-1 space-y-1">
                {row.expandRow ? (
                  ""
                ) : (
                  <ShowButton
                    className={
                      (show || showEdit || selectedRows.length > 0
                        ? "opacity-50"
                        : "opacity-100") + ""
                    }
                    disabled={
                      show || showEdit || selectedRows.length > 0 ? true : false
                    }
                    buttonText="Show"
                    onClick={() => {
                      handleActions(row, "Show");
                    }}
                  />
                )}
                {row.expandRow ? (
                  ""
                ) : (
                  <EditButton
                    className={
                      (show || selectedRows.length > 0
                        ? "opacity-50 gap-2"
                        : "opacity-100 gap-2") + ""
                    }
                    disabled={
                      show || showEdit || selectedRows.length > 0 ? true : false
                    }
                    buttonText="Edit"
                    onClick={() => {
                      handleActions(row, "Edit");
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        );
      },
    },
  ];

  const tabs = ["All", "Valid", "Invalid"];
  const handleSelectedTab = (tab, data) => {
    setSelectedTab(tab);
    switch (tab) {
      case "All":
        return setAllData(origData);
      case "Valid":
        if (data !== null) {
          const valids = data.filter((data) => data.isValid);
          return setAllData(valids);
        } else {
          setSelectedRows([]);
          const valids = origData.filter((data) => data.isValid);
          return setAllData(valids);
        }

      case "Invalid":
        if (data !== null) {
          const invalids = data.filter((data) => !data.isValid);
          return setAllData(invalids);
        } else {
          setSelectedRows([]);
          const invalids = origData.filter((data) => !data.isValid);
          return setAllData(invalids);
        }
    }
  };

  const handleClose = () => {
    setMassUpload(false);
  };

  const updatedRow = (currentData) => {
    const updatedData = origData.map((data) => {
      if (currentData.id === data.id) {
        data = currentData;
      }
      return data;
    });
    setAllData(updatedData);
    setOrigData(updatedData);
  };
  useEffect(() => {
    if (!isOpen) {
      setAllData([]);
      setOrigData([]);
      setInvalidData([]);
      setValidData([]);
    }
  }, [isOpen]);

  const handleDelete = () => {
    const ids = selectedRows.map((d) => d.id);
    const newData = origData.filter((d) => !ids.includes(d.id));
    setAllData(newData);
    setOrigData(newData);
    setOpenModal(false);
    setSelectedRows([]);
    setToggleCleared(!toggleClear);
    if (selectedTab === "Invalid" || selectedTab === "Valid") {
      handleSelectedTab(selectedTab, newData);
    }
    toast.fire(
      "Success",
      "Producer Code were deleted successfully.",
      "success"
    );
  };
  const handleSelectedRowsChange = (state) => {
    setSelectedRows(state.selectedRows);
  };

  const SaveMassUploadData = () => {
    setButtonSaveText("Saving...");
    const prodCodes = validData?.map((x: any) => {
      return {
        ...x,

        createdBy: user.username,
        modifiedBy: user.username,
        isFranchiseUser:
          user.isFranchise && user.isNonFranchise
            ? x?.isFranchise !== null
              ? x?.isFranchise
              : franchiseCheckBoxValue
            : user.isFranchise,
      };
    });
    massUploadProducerCode(prodCodes)
      .then((res) => {
        queryClient.invalidateQueries("ProducerCode");
        if (res.status === 200) {
          if (invalidData.length > 0) {
            setAllData(origData.filter((data) => !data.isValid));
            setOrigData(origData.filter((data) => !data.isValid));
            toast.fire(
              "Saved Successfully",
              "Your data has been saved",
              "success"
            );
            setButtonSaveText("Save Data");
          } else {
            setAllData([]);
            setInvalidData([]);
            setValidData([]);
            toast.fire(
              "Saved Successfully",
              "Your data has been saved",
              "success"
            );
          }
        }
        if (res.status === 400 || res.status !== 200) {
          const errMessage = res.data.title ? res.data.title : "Server Error";
          toast.fire("Saving Failed", errMessage, "error");
        }

        setButtonSaveText("Save Data");
        setSelectedTab("All");
      })
      .catch((e) => {
        toast.fire(
          "Save Failed",
          "We encountered an error when saving your data!",
          "error"
        );
      });
  };

  const DownloadTemplate = () => {
    downloadProdCodeTemplate().then((content) => {
      if (content.status === 200) {
        var url = window.URL.createObjectURL(content.data);
        let templateName =
          user.isFranchise && user.isNonFranchise
            ? "MassUploadProducerCodeTemplate.xlsx"
            : user.isFranchise
            ? "MassUploadProducerCodeTemplate_Franchise.xlsx"
            : "MassUploadProducerCodeTemplate.xlsx";
        let tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.setAttribute("download", templateName);
        tempLink.click();

        toast.fire("Success", "File downloaded successfully", "success");
      }
      if (content.status === 404) {
        toast.fire("Error downloading file:", "File not found", "error");
      }
    });
  };

  const handleActions = (row, type) => {
    const updatedData = origData.map((d: any) => {
      if (d.id === row.id) {
        d.expandRow = !d.expandRow;
      }
      return d;
    });
    if (type === "Edit") {
      setAllData(updatedData);
      setShow(false);
      setShowEdit(true);
      setDisplayNote(false);
    } else if (type === "Show") {
      setShow(true);
      setShowEdit(false);
      setDisplayNote(false);
    } else {
      setShow(false);
      setShowEdit(false);
      setDisplayNote(true);
    }
  };

  const ValidateUploadedFile = (uploadedData) => {
    setLoading(true);
    validateMassUpload(uploadedData).then((res) => {
      if (res) {
        setSelectedRows([]);
        setShow(false);
        setShowEdit(false);
        setDisplayNote(true);

        setAllData(res);
        setOrigData(res);
        var tempValidData = [null];
        var tempInvalidData = [null];
        res.map((prodCode) => {
          if (prodCode.isValid) tempValidData.push(prodCode);
          else tempInvalidData.push(prodCode);
        });
        setValidData(tempValidData);
        setInvalidData(tempInvalidData);
      } else {
        toast.fire(
          "Server Error",
          "Failed to upload file, please check server or internet connection",
          "error"
        );
      }
      setLoading(false);
      setSelectedTab("All");
    });
  };

  const getPropString = (rawRow, columnKey) => {
    const value = rawRow[columnKey];
    return value ? String(value).trim() : "";
  };

  const normalizeFranchise = (value) => {
    if (value === undefined || value === null || value === "") return false;

    const str = String(value).toLowerCase().trim();

    if (str === "true" || str === "1") return true;
    if (str === "false" || str === "0") return false;

    return Boolean(value);
  };

  const UploadFile = (e) => {
    if (e.target.files.length > 0) {
      var reader = new FileReader();
      var excelFile = e.target.files[0];
      reader.onload = (e) => {
        var result = e?.target?.result;
        try {
          var wb = xlsx.read(result, { type: "binary" });
          const xData = xlsx.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
          const hasIsFranchise = xData.some((item) =>
            item.hasOwnProperty("isFranchise (If superuser, True/False)")
          );
          if (!hasIsFranchise) {
            xData.forEach((item) => {
              item["isFranchise (If superuser, True/False)"] = null;
            });
          }
          if (
            xData.some((item) =>
              item.hasOwnProperty("Carrier Name required")
            ) &&
            xData.some((item) =>
              item.hasOwnProperty(
                "Producer Code / Princeton Code(if Carrier is National General) required"
              )
            ) &&
            !xData.some((item) => item.hasOwnProperty("Address"))
          ) {
            if (
              xData[0].hasOwnProperty("Carrier Name required") &&
              xData[0].hasOwnProperty(
                "Producer Code / Princeton Code(if Carrier is National General) required"
              ) &&
              xData[0].hasOwnProperty("Line of Business required") &&
              xData[0].hasOwnProperty("Producer Code Type required") &&
              xData[0].hasOwnProperty("Code Level required")
            ) {
              const forValidation = xData.map((prodCode) => ({
                carrierName: getPropString(prodCode, "Carrier Name required"),
                princetonAgentCode: getPropString(
                  prodCode,
                  "Agent ID required if Carrier Name is National General"
                ),
                masterAgentPrincetonId: getPropString(
                  prodCode,
                  "Master Agent ID if Carrier Name is National General"
                ),
                producerCode: getPropString(
                  prodCode,
                  "Producer Code / Princeton Code(if Carrier is National General) required"
                ),
                producerSubCodes: getPropString(prodCode, "Producer SubCode"),
                lineOfBusiness: getPropString(
                  prodCode,
                  "Line of Business required"
                ),
                storeNumber: getPropString(
                  prodCode,
                  "Store Number required if associated to Office"
                ),
                officeCode: getPropString(
                  prodCode,
                  "Office Code required if associated to Office"
                ),
                producer: getPropString(
                  prodCode,
                  "Employee Code required if associated to Producer"
                ),
                mAproducerCodes: getPropString(prodCode, "MA Producer Code"),
                program: getPropString(prodCode, "Carrier Program"),
                mga: getPropString(prodCode, "MGA"),
                producerCodeType: getPropString(
                  prodCode,
                  "Producer Code Type required"
                ),
                masterCode: getPropString(
                  prodCode,
                  "Master Code required if Master Code Status is Active"
                ),
                masterCodeStatus: getPropString(
                  prodCode,
                  "Master Code Status (Active/Inactive)"
                ),
                codeLevel: getPropString(prodCode, "Code Level required"),
                issuedTo: getPropString(prodCode, "Employee Codes Issued To"),
                crossSale: getPropString(prodCode, "Can Sell required"),
                rollUpCode: getPropString(
                  prodCode,
                  "Roll Up Code required if Roll Up Code Status is Active"
                ),
                rollUpCodeStatus: getPropString(
                  prodCode,
                  "Roll Up Code Status (Active/Inactive)"
                ),
                distributionChannel: getPropString(
                  prodCode,
                  "Distribution Channel"
                ),
                isFranchise: normalizeFranchise(
                  prodCode["isFranchise (If superuser, True/False)"]
                ),
                franchiseType: getPropString(
                  prodCode,
                  "Franchise Type(if isFranchise, Confie Franchise/Franchise)"
                ),
                billingName: getPropString(prodCode, "Billing"),
                exceptionCDRC: getPropString(
                  prodCode,
                  "CDRC Exception (True/False)"
                ),
                exceptionKeeper: getPropString(
                  prodCode,
                  "Keeper Exception (True/False)"
                ),
                exceptionAL3: getPropString(
                  prodCode,
                  "AL3 Exception (True/False)"
                ),
                notes: getPropString(prodCode, "Notes"),
              }));
              ValidateUploadedFile(forValidation);
              setDisplayNote(true);
            } else {
              toast.fire(
                "Uploading Producer Code Failed",
                "Please fill in all the required fields",
                "error"
              );

              setDisplayNote(true);
            }
          } else {
            toast.fire(
              "Uploading Producer Code Failed",
              "Invalid file or missing required columns, please check file and re-upload again",
              "error"
            );
          }
        } catch (err) {
          toast.fire(
            "Uploading Producer Code Failed",
            "Invalid file, please check file and re-upload again",
            "error"
          );
        }
      };
      reader.readAsBinaryString(excelFile);
      e.target.value = null;
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => handleClose()}
      title={undefined}
      className={undefined}
      modalFilterStat={undefined}
    >
      <ConfirmBoxDelete
        ModalTitle="Delete Producer Code"
        qConfirmation={"Are you sure you want to delete producer code(s)?"}
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        onClickFunction={() => {
          handleDelete();
          setDisplayNote(true);
        }}
        cancelButtonRef={undefined}
      />
      <div className="">
        <div className="font-bold text-xl flex items-center m-2">
          <div className="text-base text-primary font-bold">
            Producer Code Mass Upload
          </div>
          <div className="ml-auto flex items-center ">
            <TemplateButton onClick={DownloadTemplate} />
            <UploadFileButton onChange={UploadFile} disabled={false} />
          </div>
        </div>
        <div className="mt-2 h-1 w-full border-b-4 border-secondary" />
        <div>
          <div className="flex justify-between">
            <div>
              {tabs.map((tab) => {
                return (
                  <button
                    key={tab}
                    onClick={() => handleSelectedTab(tab, null)}
                    className={`border-b-4 font-medium text-sm text-tertiary cursor-pointer transition py-3 px-5  
                     ${
                       selectedTab === tab
                         ? "border-primary font-bold bg-gray-50"
                         : "border-transparent hover:bg-gray-50 "
                     }`}
                  >
                    {tab}
                  </button>
                );
              })}
            </div>
            <div className="flex items-end justify-end gap-2">
              {!showEdit &&
                !show &&
                selectedTab !== "Invalid" &&
                hasValidData && (
                  <div className="ml-auto">
                    <SaveDataButton
                      className={
                        (show || showEdit || selectedRows.length > 0
                          ? "opacity-50 cursor-not-allowed border"
                          : "opacity-100") + ""
                      }
                      disabled={show || showEdit || selectedRows.length > 0}
                      onClick={SaveMassUploadData}
                      buttonValue={buttonSaveText}
                    ></SaveDataButton>
                  </div>
                )}
            </div>
          </div>
        </div>
        <div className="flex flex-row  justify-between items-center pb-1">
          {DisplayNote && allData.length >= 1 ? (
            <div className="text-secondary italic text-xs3 mt-4">
              <p className="font-bold italic inline-block mr-1">Note: </p>
              Tick the box to delete some data.
            </div>
          ) : (
            ""
          )}
        </div>
        <div
          className={`mt-4 box-shadow ${
            showEdit || show || allData.length > 5
              ? `w-auto h-80 overflow-auto`
              : ``
          }`}
        >
          <Table
            data={allData}
            columns={columns}
            onSelectedRowsChange={handleSelectedRowsChange}
            setOpenModal={setOpenModal}
            selectableRows={DisplayNote && allData?.length > 0 ? true : false}
            expandableRows={true}
            selectedRows={selectedRows}
            clearSelectedRows={toggleClear}
            expandableRowsComponent={(row) => (
              <MassUploadFullView
                data={row.data}
                setShow={setShow}
                isEdit={showEdit}
                updateRow={(data) => updatedRow(data)}
                setShowEdit={setShowEdit}
                setDisplayNote={setDisplayNote}
                Cancel={() => handleActions(row.data, "Hide")}
                setOrigData={setOrigData}
                setAllData={setAllData}
                origData={origData}
                setValidData={setValidData}
                setInvalidData={setInvalidData}
                selectedTab={selectedTab}
                handleSelectedTab={handleSelectedTab}
              />
            )}
            expandableRowExpanded={(row) => row.expandRow}
          />
        </div>
      </div>
    </Modal>
  );
};

export default MassUpload;
